(ns app.front.view.property.v2.workspace-reassign
  (:require [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.property.v2.workspace-reassign.events :as events]
            [app.front.view.property.v2.workspace-reassign.subs :as subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [reagent.core :as r]))

;; Components

(defn- reassign-actions [tr]
  (let [property-id         (<sub [::property-subs/property-id])
        selected-workspaces (<sub [::subs/selected-workspace-ids])]
    [{:title     (tr [:property-view/reassign-selected])
      :disabled? (empty? selected-workspaces)
      :confirm?  true
      :confirm-content
      (tr [:property-view/reassign-confirmation])
      :on-click  #(>evt [::events/open-reassign-modal property-id selected-workspaces])}]))

(defn- workspace-table [tr]
  (let [items          (<sub [::subs/workspace-items])
        selected       (<sub [::subs/selected-workspace-ids])
        all-workspaces (<sub [::subs/all-workspace-ids])
        destinations   (<sub [::subs/destinations])
        reassignable?  (seq destinations)]
    (if (empty? items)
      ;; `sortable-table/table` has no `:empty-placeholder`, unlike `modern-responsive-table`.
      [:p (tr [:property-view/reassign-no-workspaces])]
      [sortable-table/table
       (merge {:id              "workspace-reassign"
               :tr              tr
               :items           items
               :id-func         :db/id
               :initial-sorting [:state :asc]
               :cols            [[:property-view/reassign-application-number
                                  :workspace/municipal-case-id
                                  {:sorting true}]
                                 [:property/ws-status :state {:sorting true}]
                                 [:property/ws-category :category {:sorting true}]
                                 [:property/ws-work-type :work-type {:sorting true}]
                                 [:property/ws-work-target :work-target {:sorting true}]]}
              (when reassignable?
                {:selection        selected
                 :perma-selecting? true
                 :on-select        #(>evt [::events/toggle-selection %1 %2])
                 :on-select-all    #(>evt [::events/set-selection all-workspaces])
                 :on-clear         #(>evt [::events/set-selection #{}])
                 :toolbar-actions  (reassign-actions tr)}))])))

(defn- destination-label [{:keys [address property-id entity-id]}]
  (cond-> (or property-id address (str entity-id))
    (and property-id address) (str " / " address)))

(defn- reassign-modal [tr]
  (when (<sub [::subs/reassigning-for-this-property?])
    (let [{:keys [workspace-ids
                  submitting?]} (<sub [::subs/reassigning])
          destinations          (<sub [::subs/destinations])
          destination           (<sub [::subs/selected-destination])
          close-fn              #(>evt [::events/close-reassign-modal])]
      [ui-modal/composed-input-modal
       {:id         "workspace-reassign-modal"
        :open       true
        :size       :xs
        :class-name "modal-overflow-visible"
        :on-close   close-fn}
       (cc/modal-header {:close-modal close-fn
                         :title       (r/as-element
                                        [:span.font-bold (tr [:property-view/reassign-modal-title])])})
       (cc/modal-body
         {:class-name "m-0"}
         [:div.space-y-4
          [:div (if (= 1 (count workspace-ids))
                  (tr [:property-view/reassign-workspaces-selected-single])
                  (tr [:property-view/reassign-workspaces-selected-multi]
                      [(str (count workspace-ids))]))]
          [ui-select/select
           {:id           "workspace-reassign-destination"
            :class-name   "full-width-select"
            :label-text   (tr [:property-view/reassign-destination])
            :allow-empty? true
            :select-text  (tr [:select-option])
            :values       destinations
            :value        destination
            :val->str     destination-label
            :on-change    #(>evt [::events/set-destination %])}]
          [:hr.mt-4.border-1.border-gray-400]])
       ;; Not `cc/modal-footer`: Carbon flexes its footer buttons to 50/50 across the full width,
       ;; and these are meant to sit together on the left.
       [:div.flex.flex-row.justify-start.gap-2.p-4.mx-4
        [ui/button {:kind     :secondary
                    :size     :field
                    :on-click close-fn}
         (tr [:cancel])]
        [ui/button {:kind     :primary
                    :size     :field
                    :disabled (or (nil? destination) (boolean submitting?))
                    :on-click #(>evt [::events/reassign])}
         (tr [:property-view/reassign])]]])))

(defn section [{:keys [tr]}]
  (when (<sub [::subs/section-visible?])
    [section/section
     :property-workspace-reassign
     (util/mmap tr)
     :property-view/reassign-title
     [:div
      [workspace-table tr]
      [reassign-modal tr]]]))
